import { candidateName } from "../../utils/candidateName";
import { createListSearch } from "../../utils/listSearch";
import React, { useState, useEffect } from "react";
import axiosInstance from "../../axios/AxiosInstance";
import { Input, Modal } from "antd";

const CreateContractCandidate = ({ contract, setContract }) => {
  const [candidates, setCandidates] = useState([]);
  const [query, setQuery] = useState("");

  const selectedCandidates = query.trim()
    ? candidates.filter(
        createListSearch(query, [
          "firstname",
          "lastname",
          "phone",
          "email",
          "town",
          "postCode",
          "qualifications",
          "pld",
        ]),
      )
    : [];
  useEffect(() => {
    let active = true;
    axiosInstance
      .get("tempworker-candidate/freelance")
      .then(({ data }) => {
        if (active) setCandidates(Array.isArray(data) ? data : []);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);
  const [, setSelectedCandidate] = useState(null);
  const [isMissingModal, setIsMissingModal] = useState(false);
  const [missingParts, setMissingParts] = useState([]);

  const selectCandidate = (candidate) => {
    setSelectedCandidate(candidate);
    const newMissingParts = [];
    if (!candidate.title) {
      newMissingParts.push("Civilité");
    }
    if (!candidate.firstname) {
      newMissingParts.push("Prénom");
    }
    if (!candidate.lastname) {
      newMissingParts.push("Nom");
    }
    if (!candidate.dob) {
      newMissingParts.push("Date de naissance");
    }
    if (!candidate.email) {
      newMissingParts.push("Email");
    }
    if (!candidate.phone) {
      newMissingParts.push("Téléphone");
    }
    if (!candidate.birthTown) {
      newMissingParts.push("Ville de naissance");
    }
    if (!candidate.birthDepartment) {
      newMissingParts.push("Département de naissance");
    }
    if (!candidate.birthCountry) {
      newMissingParts.push("Pays de naissance");
    }
    if (!candidate.securityNumber) {
      newMissingParts.push("Numero de sécurité sociale");
    }
    if (!candidate.nationality) {
      newMissingParts.push("Nationalité");
    }
    if (!candidate.address) {
      newMissingParts.push("Adresse");
    }
    if (!candidate.postCode) {
      newMissingParts.push("Code postal");
    }
    if (!candidate.town) {
      newMissingParts.push("Ville");
    }

    setContract({ ...contract, candidate });
    axiosInstance
      .get(`document/id/${candidate._id}`)
      .then((res) => {
        console.log(res.data);
        if (!res.data.length) {
          newMissingParts.push("Document d'identité");
        }
        if (newMissingParts.length && !candidate.pld) {
          setMissingParts(newMissingParts);
          setIsMissingModal(true);
        }
      })
      .catch((e) => console.log(e));
  };
  const search = setQuery;

  return (
    <div className="w-full space-y-2">
      {isMissingModal && (
        <Modal
          open={isMissingModal}
          footer={null}
          onCancel={() => setIsMissingModal(false)}
        >
          <div className="h-[400px]">
            <p className="font-semibold text-2xl">Informations manquantes</p>
            {missingParts.map((part) => {
              return <p className="text-red-600 mt-4 font-semibold">{part}</p>;
            })}
          </div>
        </Modal>
      )}
      <p className="text-sm font-semibold text-slate-900">Candidat</p>
      <p className="text-xs text-slate-500">
        La fiche du candidat doit être complète pour créer le contrat.
      </p>
      <Input
        className="text-sm text-slate-900 rounded-lg placeholder-slate-400"
        placeholder="Rechercher un candidat"
        onChange={(e) => search(e.target.value)}
      />
      {selectedCandidates.length > 0 && (
        <div className="flex flex-col gap-2 rounded-lg max-h-48 overflow-y-auto">
          {selectedCandidates.map((candidate, idx) => {
            return (
              <div
                key={idx}
                onClick={() => selectCandidate(candidate)}
                className={`border px-3 py-2 rounded-lg border-slate-200 ${
                  contract.candidate?._id === candidate._id
                    ? "bg-blue-50 border-blue-200"
                    : ""
                }`}
              >
                <div className="flex items-start space-x-3 justify-between mx-2">
                  <div>
                    <p className="text-sm font-semibold text-slate-900">
                      {candidateName(candidate)}
                    </p>
                    <p className="text-xs text-slate-500">{candidate.email}</p>
                    <p className="text-xs text-slate-500">{candidate.phone}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {contract.candidate && selectedCandidates.length === 0 && (
        <div
          className={`border px-3 py-2 rounded-lg border-slate-200 bg-blue-50`}
        >
          <p className="text-sm font-semibold text-slate-900">
            {candidateName(contract.candidate)}
          </p>
          <p className="text-xs text-slate-500">{contract.candidate.email}</p>
          <p className="text-xs text-slate-500">{contract.candidate.phone}</p>
        </div>
      )}
    </div>
  );
};

export default CreateContractCandidate;
